module.exports = ".period {\n  color: #7f96a3;\n}\n"